export const assignHelper = (attributeName) => (state, value) => {
  state[attributeName] = value;
};